import React from 'react';
import { size } from "lodash";
import { Box, Button, Chip, Icons, Typography } from '@curves/ui-base';

import { useChartContext } from "@Local/Dashboard/Components/ChartContext";
import { dataTypeMap } from "@Local/Dashboard/staticData";

const StatisticsDataTypeSelectBox = (props) => {
    const {
        sourceData
    } = props;
    const {
        dataType,
        getDialog,
        selectedStatistics,
        setSelectedStatistics,
        setSourceData,
    } = useChartContext();
    const doRefresh = () => {
    };
    const doConfirmStatistics = (selected) => {
        setSelectedStatistics(selected);
        setSourceData(null);
    };
    const handleSelectDataType = () => {
        const dialog = getDialog();
        const {
            memberStatisticsGroupOptions,
            nonMembershipStatisticsGroupOptions,
            coachStatisticsGroupOptions
        } = sourceData;
        const switchOptions = {
            [dataTypeMap.statisticsMemberAbout]: { memberGroupOptions: memberStatisticsGroupOptions },
            [dataTypeMap.statisticsNonMembership]: { nonMembershipGroupOptions: nonMembershipStatisticsGroupOptions },
            [dataTypeMap.statisticsCoach]: { coachGroupOptions: coachStatisticsGroupOptions },
        }
        const targetOptions = switchOptions[dataType] || {};
        dialog.openAdvancedChartFilterStatisticsDialog(targetOptions,
            doRefresh, selectedStatistics, doConfirmStatistics);
    }
    return (
        <Box onClick={handleSelectDataType}>
            {size(selectedStatistics) > 0 ? (
                <Box className="tag-selector-box">
                    <Typography>統計項目</Typography>
                    {selectedStatistics && selectedStatistics.map((item) => {
                        const { mainGroupType, subGroupType, dataType, dataTypeText } = item;
                        const key = `${mainGroupType}::${subGroupType}-${dataType}`;
                        return <Chip key={key} label={dataTypeText} color={'primary'} />;
                    })}
                    <Box className={'text-right cursor-pointer'}>
                        <Icons.Edit color={"primary"} fontSize={'small'} />
                    </Box>
                </Box>
            ) : (
                <Button color="primary"><Icons.Plus color={"primary"} /> 選擇營運報表項目</Button>
            )}
        </Box>
    );
};
export default StatisticsDataTypeSelectBox;